import React from 'react';
import styles from './landpageStepIcons.module.css';

export const AppleStoreIcon: React.FC = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M16.365 1.43c0 1.14-.417 2.053-1.252 2.74-.836.687-1.98 1.027-3.433 1.02-.02-1.09.403-2.002 1.268-2.737.865-.735 2.007-1.113 3.417-1.023zm.12 3.71c1.57.02 2.92.84 4.05 2.46-3.59 2.09-3.01 6.25-1.2 7.98-.9 1.17-1.86 2.34-3.36 2.36-1.2.02-1.56-.35-2.92-.35-1.37 0-1.79.36-2.92.38-1.48.03-2.61-1.58-3.51-2.75C4.24 13.1 3.47 9.03 5.18 6.62c.84-1.24 2.17-2.01 3.56-2.03 1.4-.02 2.72.93 3.42.93.7 0 2.01-1.15 3.39-.98.58.02 2.21.23 3.26 1.74-.08.05-1.95 1.14-1.93 3.4z"
    />
  </svg>
);

export const AndroidStoreIcon: React.FC = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M3.6 2.8l9.2 5.3V2.1L4.9 1.1A1.2 1.2 0 003.6 2.8zm-.9 14.9a1.2 1.2 0 001.3.7l8.4-4.8-2.1-1.2-7.6 5.3zm17.7-9.1l-3.2-1.8-2.3 2 2.3 2 3.2-1.8a1.2 1.2 0 000-2.1zm-4.5 7.8l-8.4-4.8v5.9l9.2 5.3a1.2 1.2 0 001.3-.7l-2.1-5.7zM12 11.3L3.6 6l8.4 4.8L20.4 6 12 11.3z"
    />
  </svg>
);

export const PlayTutorialIcon: React.FC = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M8 5v14l11-7z" />
  </svg>
);
